import { Component } from '@angular/core';

@Component({
  selector: 'app-polaris-icon',
  imports: [],
  templateUrl: './polaris-icon.component.html',
  styleUrl: './polaris-icon.component.scss'
})
export class PolarisIconComponent {

}
